import * as React from 'react';

import classnames from 'classnames';

import {InfoCircleRegularIcon} from '../icon/svg/info-circle-regular-icon';

import styles from './help-styles.module.css';

type Props = {
    onClick: (e: React.MouseEvent) => void;
    variant?: 'error' | 'green' | 'blue' | 'greyLt';
    size?: number;
    noPadding?: boolean;
};

// @ts-expect-error
export const HelpButton = React.forwardRef<Props, HTMLButtonElement>((props: Props, ref) => {
    const getVariantStyleName = () => {
        if (props.variant === 'error') {
            return styles['help-icon--error'];
        }

        if (props.variant === 'green') {
            return styles['help-icon--green'];
        }

        if (props.variant === 'blue') {
            return styles['help-icon--blue'];
        }

        if (props.variant === 'greyLt') {
            return styles['help-icon--grey-lt'];
        }

        return styles['help-icon'];
    };

    const className = classnames(getVariantStyleName(), {
        [styles['help-icon--no-padding']]: props.noPadding,
    });

    return (
        // @ts-expect-error
        <button type='button' onClick={props.onClick} ref={ref} className={className}>
            <InfoCircleRegularIcon wrapWithDiv={false} size={props.size ? props.size : 16} />
        </button>
    );
});
